<template id="buy-box">
    <div>
        <Header/>
            <div class="main-grid">
                <div class="shopping-cart">

                    <div style="padding: 10px 0px;" v-for="c in cartArr" v-bind:key="c.id">
                        <div class="item" v-if="c.cart !== 0">
                            <button @click="destroy(c)" class="des-btn" >
                                <i class="fa fa-ban"></i>
                            </button>
                            <div class="image">
                                <img class="cart-image" :src="c.image"/>
                            </div>
                            <div class="quantity">
                                <button @click="plus(c)" class="quan-btn plus-btn" >
                                    <i class="fa fa-plus"></i>
                                </button>
                                <input :value="c.cart"
                                />
                                <button @click="minus(c)" class="quan-btn minus-btn" >
                                    <i class="fa fa-minus"></i>
                                </button>
                            </div>
                            <div class="description">
                                <div class="description-amount-title">
                                    <span>{{c.title}}</span>
                                    <div v-if="c.discount_value || c.discount_percent">
                                        <span v-if="c.discount_value" class="price">{{c.amount - c.discount_value}} ریال</span>
                                        <span v-if="c.discount_percent" class="price">{{c.amount - c.amount * (c.discount_percent / 100) }} ریال</span>
                                        <span class="discount-price">{{c.amount}} ریال</span>
                                    </div>
                                    <div v-else>
                                        <span style="float: left;font-size: 20px;margin: 10px 10px;color:#55595e;">{{c.amount }} ریال</span>
                                    </div>
                                </div>
                                <div>
                                    <span>{{c.description}}</span>
                                </div>

                            </div>
                        </div>

                    </div>
                    <div class="empty-main" v-if="total === 0">
                        <div class="empty-list-cart">
                            <i class="fa fa-shopping-cart"></i>
                            <h1>سبد کالا خالی است</h1>
                            <h4>لطفا برای خرید کالا اول می‌بایست از صفحه فروشگاه محصول مورد نظر را انتخاب کنید</h4>
                        </div>
                    </div>
                </div>

                <div class="side-result">
                    <div class="summary">
                        <div class="result-row">
                            <h5>جمع کل :</h5>
                            <h6 style="margin: 4px 13px; text-align: left;">{{total.toFixed(2)}} ریال</h6>
                        </div>
                        <div class="result-row">
                            <h5>مقدار تخفیف :</h5>
                            <h6  style="margin: 4px 13px; text-align: left;">{{total_discount.toFixed(2)}} ریال</h6>
                        </div>
                        <div class="result-row last">
                            <h5>جمع کل با تخفیف :</h5>
                            <h6 style="margin: 4px 13px; text-align: left;">{{total.toFixed(2) - total_discount.toFixed(2)}} ریال</h6>
                        </div>
                        <div>
                            <div class="result-row">
                                <h5>مبلغ قابل پرداخت :</h5>
                                <h6 style="margin: 4px 13px; text-align: left;">{{total.toFixed(2) - total_discount.toFixed(2)}} ریال</h6>
                            </div>
                            <div class="coupon-pay">
                                <div style="height: 70px;" class="submit-div" >
                                    <button class="pay-btn">پرداخت</button>
                                </div>
                                <form  @submit.prevent="checkCoupon" id="product_form">
                                    <input v-model="coupon" name="coupon" class="submit-input"  placeholder="کد تخفیف را وارد کنید"/>
                                    <button id="submit_btn" type="submit" class="pay-btn submit-coupon">بررسی کد تخفیف</button>
                                </form>
                            </div>

                        </div>

                    </div>

                </div>

            </div>

    </div>

</template>

<script>
    import Header from './components/header'
    import {mapGetters} from "vuex";
    import $ from "jquery";
    import { KTApp } from '@/plugins/core/app'
    import {storeService} from "../../common/api.service";
    export default {
        data() {
            return {
                cartArr:[],
                total: 0,
                total_discount:0,
                total_with_discount:0,
                payable:0,
                coupon:'',
                submitedCoupon:[],
            };
        },
        components:{
            Header
        },
        computed:{
            ...mapGetters('cart',['cart']),



        },

        created(){
            if(localStorage.getItem('allCart') != null ){
                if (this.cart.length !== JSON.parse( (localStorage.getItem('allCart'))).length){
                    for (var i = 0 ; i < JSON.parse(localStorage.getItem('allCart')).length ; i++){
                        if (JSON.parse(localStorage.getItem('allCart'))[i] && JSON.stringify(localStorage.getItem('allCart'))[i]){
                            this.$store.dispatch('cart/add',JSON.parse(localStorage.getItem('allCart'))[i])
                        }
                    }
                }
            }
            for (let i = 0 ; i < this.cart.length - 1; i++){
                this.cartArr.push(this.cart[i + 1]);
                this.total += this.cart[i + 1].amount * this.cart[i + 1].cart;
                if (this.cart[i + 1].discount_value){
                    this.total_discount += this.cart[i + 1].discount_value * this.cart[i + 1].cart
                }else{
                    this.total_discount += this.cart[i + 1].amount * (this.cart[i + 1].discount_percent / 100) * this.cart[i + 1].cart
                }
            }
        },

        methods:{
            destroy(data){
                for (var i = 0 ; i < this.cartArr.length; i++){
                    if(this.cartArr[i].id === data.id ){
                        this.total -=  this.cartArr[i].count * data.amount
                        if (this.cartArr[i].discount_value){
                            this.total_discount -= this.cartArr[i].count * this.cartArr[i].discount_value
                        }else{
                            this.total_discount -= this.cartArr[i].count * (this.cartArr[i].amount * (this.cartArr[i].discount_percent / 100))
                        }
                    }
                }
                this.$store.dispatch('cart/remove',data)
                localStorage.setItem('allCart',JSON.stringify(this.cartArr[i]))
            },
            minus(data){

                for (var i = 0 ; i < this.cartArr.length; i++){
                    if(this.cartArr[i].id === data.id ){
                        if(this.cartArr[i].cart !== 0){
                            this.cartArr[i].cart--
                            this.total -= data.amount
                            if (this.cartArr[i].discount_value){
                                this.total_discount -= this.cartArr[i].discount_value
                            }else{
                                this.total_discount -= (this.cartArr[i].amount * (this.cartArr[i].discount_percent / 100))
                            }
                            if (this.cartArr[i].cart === 0){
                                this.$store.dispatch('cart/remove',data)
                                localStorage.setItem('allCart',JSON.stringify(this.cart[i + 1]))
                            }
                        }
                    }
                }
            },
            plus(data){

                for (var i = 0 ; i < this.cartArr.length  ; i++){
                    if(this.cartArr[i].cart !== this.cartArr[i].quantity){
                        if(this.cartArr[i].id === data.id ){
                            this.cartArr[i].cart++;
                            this.total += data.amount;

                            if (this.cartArr[i].discount_value){
                                this.total_discount += this.cartArr[i].discount_value
                            }else{
                                this.total_discount += (this.cartArr[i].amount * (this.cartArr[i].discount_percent / 100))
                            }
                        }
                    }

                }
            },
            checkCoupon(e) {

                let form = $(e.target)

                form.validate({
                    rules: {
                        coupon: {
                            required: true,
                        },
                    },
                });
                if (this.coupon){
                    let btn = $('#submit_btn')
                    KTApp.progress(btn)
                    storeService.checkCoupon(this.coupon)
                        .then(response => {
                            this.submitCoupon(response.data.data)
                            this.showMsg(form, 'success',response.data.message)
                            this.coupon = ''
                        })
                        .catch(({response}) => {
                            if(response.data) {
                                form.validate().showErrors(response.data.data)
                                this.showMsg(form, 'danger',response.data.message)
                            }
                        })
                        .finally(() => {
                            KTApp.unprogress(btn)
                        })
                }
            },
            submitCoupon(data){
                if (!this.submitedCoupon.includes(data)){
                    this.submitedCoupon.push(data)
                    if (data.percent_off){
                        if (data.max_amount < this.total * (data.percent_off / 100)){
                            this.total_discount += data.max_amount
                        }else{
                            this.total_discount += this.total * (data.percent_off / 100)
                        }
                    }else{
                        this.total_discount += data.value
                    }
                }
            }
        }




    }

</script>

<style>
    .main-grid{
        display: grid;

        grid-template-columns: 70% 29%;
    }
    .store-header{
        height: 80px;
        background-color: #212529;
        display: block;
    }
    .cart-header-btn{
        margin: 20px 10px;
        padding: 10px 20px;
        background-color: rgba(29, 201, 183, 0.1);
        border: 0;
        border-radius: 2px;
        color: #1dc9b7;
    }
    .shopping-cart {
        width: 95%;
        height: auto;
        margin: 10px auto;
        border-radius: 2px;
        padding: 10px;
        display: flex;
        flex-direction: column;
    }
    .title {
        height: 60px;
        border-bottom: 1px solid #E1E8EE;
        padding: 20px 30px;
        color: #5E6977;
        font-size: 18px;
        font-weight: 400;
    }
    .summary {
        height: 10px;
        padding: 20px 30px;
        color: #5E6977;
        font-size: 18px;
        font-weight: 400;
        display: grid;
    }
    .cart-image{
        width: 110%;
        float: right;
        border-radius: 6px;
    }
    .item {
        padding: 25px 15px;
        display: grid;
        grid-template-columns: 4% 15% 17% 66%;
        background-color: white;
        border-radius: 5px;
        box-shadow: 1px 2px 11px -4px  rgba(0,0,0,0.10);
    }

    .item:nth-child(3) {
        border-top:  1px solid #E1E8EE;
        border-bottom:  1px solid #E1E8EE;
    }

    @keyframes animate {
        0%   { background-position: left;  }
        50%  { background-position: right; }
        100% { background-position: right; }
    }

    .is-active {
        animation-name: animate;
        animation-duration: .8s;
        animation-iteration-count: 1;
        animation-timing-function: steps(28);
        animation-fill-mode: forwards;
    }

    @keyframes animate {
        0%   { background-position: left;  }
        50%  { background-position: right; }
        100% { background-position: right; }
    }
    .image {
        margin-right: 20px;
    }

    .description {
        padding-top: 10px;
        margin-left: 17px;
        background-color:
                #fdfdfd;
        border-radius: 6px;
        border: 1px solid
        #00000024;
        display: grid;
        grid-template-rows: 40px 50px;
    }

    .description span {
        display: block;
        font-size: 14px;
        color: #43484D;
        font-weight: 400;

    }

    .description span:first-child {
        margin: 2px 10px;
    }
    .description span:last-child {
        font-weight: 300;
        float: right;
        color: #86939E;


    }
    .empty-main{
        padding: 20px;
        background-color: white;
        margin: 20px;
        box-shadow: 1px 2px 3px 0px
        rgba(0,0,0,0.10);
        border-radius: 5px;
        height: 250px;
    }
    .empty-list-cart{
        padding: 30px;
    }
    .empty-list-cart > i {
        font-size: 60px;
        text-align: center;
        width: 100%;
    }
    .empty-list-cart > h1{
        padding: 5px;
        text-align: center;
    }
    .empty-list-cart > h4 {
        text-align: center;
    }
    .discount-amount{
        margin: 10px;
    }
    .full_amount{
        text-align: end;
        font-size: 20px;
        margin: 10px 10px;
    }
    .quantity {

        padding: 70px 23px 5px;
        display: flex;
    }
    .quantity input {
        -webkit-appearance: none;
        border: none;
        text-align: center;
        width: 32px;
        font-size: 16px;
        color: #43484D;
        font-weight: 300;
        border-radius: 2px;
        margin: 0px 5px;
        border: 1px solid rgba(0, 0, 0, 0.27)
    }
    .quan-btn{
        border: 1px solid #e9e9e9;
        color: white;
        background-color: #aeaeae75;
        border-radius: 6px;
    }

    .minus-btn img {
        margin-bottom: 3px;

    }
    .plus-btn img {
        margin-top: 2px;
    }
    .discount-price{
        margin: -30px 0px 0px 0px;
        text-decoration: line-through;
    }
    .price{
        text-align: end;
        font-size: 20px;
        margin: 10px 10px;
    }
    button:focus,
    input:focus {
        outline:0;
    }
    .total-price {
        width: 83px;
        padding-top: 27px;
        text-align: center;
        font-size: 16px;
        color: #43484D;
        font-weight: 300;
    }
    @media (max-width: 800px) {
        .main-grid{
            grid-template-columns: 1fr;
        }
        .shopping-cart {
            width: 90%;
            height: auto;
            overflow: hidden;
            padding: 20px;
        }
        .item {

            height: auto;
            display: grid;
            grid-template-columns: 1fr;
            grid-template-rows: 0px 10px;
        }
        .image img {
            width: 100px;
            float: left;
        }
        .image,
        .quantity,
        .description {
            width: 100%;
            text-align: start;
            margin: 6px 0;



        }
        .des-btn{
            width: 40px;
            height: 40px;
        }
        .cart-header-btn {
            margin: 20px 10px;
        }

        .discount-price{
            margin: -20px -40px 0px 0px;
        }
        .price{
            font-size: 10px;
        }
        .empty-main{
            height: 330px;
        }
    }

    .des-btn{
        border: 1px solid #e9e9e9;
        color: white;
        background-color: #aeaeae75;
        border-radius: 6px;
    }
    .cart-header{
        position: absolute;
        width: 100%;
        padding: 20px;
        text-align: center;
    }
    .cart-header > h2 {
        margin: 10px 30%;
        background-color: #f0f0f0;
        color: black;
        border-radius: 6px;
    }
    .result-row{
        display: grid;
        grid-template-columns: 1fr 1fr;
        padding: 10px 0px;
    }
    .last {
        border-bottom: 1px solid black;
    }
    .coupon-pay{
        display: grid;
        grid-template-rows: 1fr 1fr 1fr;
        grid-gap: 10px;
        height: 0;
    }
    .side-result{
        height: 500px;
        width: 95%;
        margin: 30px auto;
        background:
                #FFFFFF;
        box-shadow: 1px 2px 3px 0px
        rgba(0,0,0,0.10);
        border-radius: 5px;
        padding: 10px;
    }
    .pay-btn{
        padding: 5px;
        border: 0;
        border-radius: 2px;
        margin: 12px;
        background-color: #1bbcab;
        width: 93%;
        color:white;
    }
    .submit-coupon{
        margin: 10px 10px 20px;
        background-color: lightgrey;
    }
    .submit-input{
        margin: 10px 10px 10px;
        border: 1px solid;
        border-radius: 2px;
        padding: 0px 10px;
        height: 40px;
        width: 93%;
    }
    .submit-div{
        border-bottom: 1px solid black;
    }
    #coupon-error{
        display: block;
        font-size: 10px;
        margin: -7px 10px 0px;
        position: absolute;
    }

    .description-amount-title{

        display: grid;
        grid-template-columns: 2fr 1fr;
    }

</style>